import { initializeApp } from 'firebase/app';
import 'crypto-js';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

const U_I_D = 'comics_v1_u_i_d';
const HISTORY = 'comics_v1_visit_records';

export function setItem(key, value, expireTime = 0) {
  const data = {
    value,
    isExpire: expireTime > 0,
    expireTime,
    saveTime: new Date().getTime(),
  };
  localStorage.setItem(key, JSON.stringify(data));
}

export function getItem(key) {
  const result = JSON.parse(localStorage.getItem(key) || '{}');
  const { isExpire, expireTime = '', saveTime = '' } = result;
  if (isExpire) {
    const now = new Date().getTime();
    const diff = now - saveTime;
    if (diff > expireTime) {
      return undefined;
    }
    setItem(key, result.value, expireTime - diff);
  }
  return result.value;
}

export function debounce(func, wait, immediate = true) {
  let timeout; let
    result;
  return function handle(...rest) {
    const context = this;
    const args = rest;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      const callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      if (callNow) result = func.apply(context, args);
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
    return result;
  };
}

export function pxToVw(px, unitPrecision = 6) {
  px = parseFloat(px) || 0;
  return `${((px / 360) * 100).toFixed(unitPrecision)}vw`;
}

export function sliceStr(str, num, suffix = '...') {
  if (str.length <= num) return str;
  return str.slice(0, num) + suffix;
}

export function priceTransfer(price = 0) {
  const fixNum = ((Number(price) || 0) / 100).toFixed(2);
  const floatNum = parseFloat(fixNum);
  return floatNum.toString().includes('.') && floatNum.toString().split('.').length > 2 ? fixNum.toFixed(2) : fixNum;
}

export function loadScript(src, callback) {
  const script = document.createElement('script');
  script.charset = 'UTF-8';
  // eslint-disable-next-line
  script.onload = script.onreadystatechange = function () {
    if (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete') {
      callback && callback();
    }
  };
  script.src = src;
  document.getElementsByTagName('head')[0].appendChild(script);
}

export function loadImage(src) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = src;
    img.onload = () => {
      img = null;
      resolve();
    };
    img.onerror = reject;
  });
}

// Google 登录
export async function googleLogin() {
  return new Promise((resolve, reject) => {
    const firebaseConfig = {
      apiKey: 'AIzaSyD3heFhWfQj-q-3gOFGUbFF7g5m8Oy3Zp0',
      authDomain: 'toon-frenzy.firebaseapp.com',
      projectId: 'toon-frenzy',
      storageBucket: 'toon-frenzy.firebasestorage.app',
      messagingSenderId: '327589862330',
      appId: '1:327589862330:web:63361a17094db275421b83',
      measurementId: 'G-FSJ2M5QHS6',
    };
    // Initialize Firebase
    initializeApp(firebaseConfig);
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/userinfo.email');
    provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
    const timer = setTimeout(() => {
      reject(new Error('Operation timed out'));
    }, 5000);
    fetch('https://www.googleapis.com/auth/userinfo.profile')
      .then((respond) => {
        console.log(respond);
        clearTimeout(timer);
      })
      .catch((error) => {
        clearTimeout(timer);
        console.error('There was a problem with the fetch operation:', error);
      });
    signInWithPopup(auth, provider)
      .then((result) => {
        console.log(result);
        const { email = '', accessToken: access_token = '' } = result.user;
        resolve({ access_token, email });
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });
}

export function getUrlParams(url = window.location.href) {
  if (!url || typeof url !== 'string' || url.indexOf('?') === -1) return {};
  const arr = url.slice(url.indexOf('?') + 1).split('&');
  const obj = arr.reduce((res, cur) => {
    const [key, val = ''] = cur.split('=');
    const value = val.split('#')[0];
    if (key) res[key] = value;
    return res;
  }, {});
  return obj;
}

export function getUrlParamByKey(key, url = window.location.href) {
  if (!key) return '';
  const res = getUrlParams(url);
  return res?.[key] || '';
}

export function generateUuid() {
  let res = getItem(U_I_D);
  if (res) return res;
  if (typeof crypto === 'object' && typeof crypto.randomUUID === 'function') {
    res = crypto.randomUUID();
  }
  if (typeof crypto === 'object' && typeof crypto.getRandomValues === 'function' && typeof Uint8Array === 'function') {
    const randomValues = crypto.getRandomValues(new Uint8Array(32));
    res = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c, i) => {
      const random = randomValues[i] & 0xf;
      return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16);
    });
  }
  let timestamp = new Date().getTime();
  let performanceNow = (typeof performance !== 'undefined' && performance.now ? performance.now() * 1000 : 0);
  res = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let random = Math.random() * 16;
    if (timestamp > 0) {
      random = (timestamp + random) % 16 | 0;
      timestamp = Math.floor(timestamp / 16);
    } else {
      random = (performanceNow + random) % 16 | 0;
      performanceNow = Math.floor(performanceNow / 16);
    }
    return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16);
  });
  setItem(U_I_D, res);
  return res;
}

export function saveVisitRecords(data) {
  const history = getItem(HISTORY) || [];
  const { id } = data;
  const list = history.filter((im) => (im.id !== id));
  list.unshift(data);
  setItem(HISTORY, list);
}

export function delVisitRecords(ids = []) {
  const history = getItem(HISTORY) || [];
  const list = history.filter((item) => !ids.includes(item.id));
  setItem(HISTORY, list);
}

export function paginate(data, page = 1, pageSize = 10) {
  page = Math.max(1, parseInt(page, 10) || 1);
  pageSize = Math.max(1, parseInt(pageSize, 10) || 10);

  const total = data.length;
  const totalPages = Math.ceil(total / pageSize);

  const startIndex = (page - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, total);

  return {
    data: data.slice(startIndex, endIndex),
    page,
    pageSize,
    hasNext: page < totalPages,
  };
}
export function paginateFromEnd(data, page = 1, pageSize = 10) {
  page = Math.max(1, parseInt(page, 10) || 1);
  pageSize = Math.max(1, parseInt(pageSize, 10) || 10);

  const total = data.length;
  const totalPages = Math.ceil(total / pageSize);

  const startIndex = total - (page * pageSize);
  const endIndex = Math.min(total, startIndex + pageSize);

  return {
    data: page <= totalPages ? data.slice(Math.max(0, startIndex), endIndex) : [],
    page,
    pageSize,
    hasNext: page < totalPages,
  };
}

export function formatDate(timeStr, pattern = 'hh:mm') {
  if (!timeStr) return '';
  const date = new Date(timeStr);
  let str = pattern;
  const types = ['YYYY', 'MM', 'DD', 'hh', 'mm', 'ss'];
  const dates = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()];
  for (let i = 0; i < types.length; i++) {
    str = str.replace(types[i], (dates[i] < 10 ? ('0' + dates[i]) : dates[i]));
  }
  return str;
}
